import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {OrderComponent} from "../../order-manager/order/order.component";
import {OrdersService} from "../../../services-otc/orders.service";
import {Router} from "@angular/router";
import {OrdersModel} from "../../../models-otc/orders-model";
import {catchError, throwError} from "rxjs";
import {NavBarComponent} from "../../../../nav-bar/nav-bar.component";
import { RepresentativeModel } from 'src/app/order-to-cash/models-otc/representative-model';

@Component({
    selector: 'app-create-new-order',
    templateUrl: './create-new-order.component.html',
    styleUrls: ['./create-new-order.component.css'],
    standalone: false
})
export class CreateNewOrderComponent {

  orderObj: OrdersModel = <OrdersModel>{};

    private representative: RepresentativeModel;

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<OrderComponent>,
      private ordersService: OrdersService,
      private router: Router,
      public nav: NavBarComponent,
  ) {

  }

  cancelAddingNewOrder() {
    this.dialogRef.close();
  }

  //// CREATE UPDATE RETRIEVE ORDER DETAILS ////
  createNewOrder() {
    this.nav.toggleLoading(true);
     // first save 
      if(sessionStorage.getItem('representative') !== null){
        this.representative =  JSON.parse(sessionStorage.getItem('representative'));
      }
      
        this.ordersService.postNewOrder(this.representative?.representativeId)
        .pipe(
            catchError((error) => {
              console.error(error);
              return throwError(() => error);
            })
        )
        .subscribe((responseOrderId) => {
          // GET ORDER response = orderID
          this.ordersService
              .getOrderById(responseOrderId)
              .pipe(
                  catchError((error) => {
                    console.error(error);
                    return throwError(() => error);
                  })
              )
              .subscribe((responseOrderDetails) => {
                this.orderObj = responseOrderDetails;
                this.router.navigate(['/order-manager/order', responseOrderId]);
                this.dialogRef.close();
              });
        });
      }
  

}



